export const ClickLayer = (category, classes, id, text, url, hostname) => {
  if (process.env.REACT_APP_GOOGLE_GA4 == 'yes') {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ event_data: null });  // Clear the previous event_data object.
    dataLayer.push({
      event: 'click',
      event_data: {
        category: 'cta',
        link_classes: classes ? classes : '',
        link_cta: category ? category : 'menuclick',
        link_id: id ? id : '',
        link_text: text ? text : '',
        link_url: url ? url : '',
        link_hostname: hostname ? hostname : '',
      }
    });
  }
}

export const PageView = () => {
  if (process.env.REACT_APP_GOOGLE_GA4 == 'yes') {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ page_data: null});  // Clear the previous attributes.
    dataLayer.push({
      event: 'page_view',
      page_data: {
        language: process.env.REACT_APP_LOCALE || 'en',
        page_hostname: location.hostname,
        page_location: location.href,
        page_referrer: '',
        page_title: document.getElementsByTagName('title')[0].innerText,
        site_brand: 'acuvue',
        site_country: location.pathname.replaceAll('/', '') == '' ? 'N/A' : location.pathname.replaceAll('/', ''),
        site_environment: process.env.REACT_APP_ENV,
        site_gfo: 'acuvue',
        site_region: 'APAC',
      },
    });
  }
}